import axios from 'axios';
import { aqtStore } from '../../Components/State/Store';

export const API = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete'
}

const client = () => {

  async function api(url, method, metaData) {

    const authHeader = {}
    let data;
    authHeader['Authorization'] = `Bearer ${aqtStore.getState().session.idToken.jwtToken}`

    if(method === API.POST || method === API.PUT) {
      data = metaData;
    }

    try {
      const response = await axios({
        url,
        method,
        data,
        headers: {
          ...authHeader
        }
      });


      return response;
    } catch(err) {
      throw new Error(err);
    }
  }

  return {
    get: async function (url) {
      const resp = await api(url, API.GET);
      return resp;
    },
    post: async function (url, args) {
      const resp = await api(url, API.POST, args);
      return resp && resp.data;
    },
  }

}


export default client();
